function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#FF6060",
  fillRule: "evenodd",
  stroke: "#FF6C6B",
  d: "M9.126.214l.66.66L6.159 4.5l3.627 3.626-.66.66L5.5 5.159 1.874 8.786l-.66-.66L4.841 4.5 1.214.874l.66-.66L5.5 3.841 9.126.214z"
});
function SvgIconRejected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 10,
    viewBox: "0 0 11 10"
  }, props), _ref);
}
export default "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='11' height='10' viewBox='0 0 11 10'%3e %3cpath fill='%23FF6060' fill-rule='evenodd' stroke='%23FF6C6B' d='M9.126.214l.66.66L6.159 4.5l3.627 3.626-.66.66L5.5 5.159 1.874 8.786l-.66-.66L4.841 4.5 1.214.874l.66-.66L5.5 3.841 9.126.214z'/%3e %3c/svg%3e";
export { SvgIconRejected as ReactComponent };